import * as React from 'react';
import Common from '../../utilities/common';
import { Entity, PermissionLevel } from '../../utilities/Permisos';
import $ from "jquery";
import { Box, Button, Chip, Grid, Paper, Typography } from '@mui/material';
import Layout from '../../components/Utilities/Layout';
import SecurityTrimmer from '../../components/Utilities/SecurityTrimmer';
import EntityPermissions from '../../components/EntityPermissions';
import HomeWorkOutlinedIcon from '@mui/icons-material/HomeWorkOutlined';
import ComunidadAutonomaTotal from './ComunidadAutonomaTotal';
import StorageIcon from '@mui/icons-material/Storage';
import CakeOutlinedIcon from '@mui/icons-material/CakeOutlined';
import LocalPhoneOutlinedIcon from '@mui/icons-material/LocalPhoneOutlined';
import AlternateEmailOutlinedIcon from '@mui/icons-material/AlternateEmailOutlined';
import SignpostOutlinedIcon from '@mui/icons-material/SignpostOutlined';
import TrafficOutlinedIcon from '@mui/icons-material/TrafficOutlined';
import HolidayVillageOutlinedIcon from '@mui/icons-material/HolidayVillageOutlined';
import LocationCityOutlinedIcon from '@mui/icons-material/LocationCityOutlined';
import LightOutlinedIcon from '@mui/icons-material/LightOutlined';
import LocalFireDepartmentOutlinedIcon from '@mui/icons-material/LocalFireDepartmentOutlined';
import WomanIcon from '@mui/icons-material/Woman';
import ManIcon from '@mui/icons-material/Man';
import ComunidadAutonomaProvinciasSexo from './ComunidadAutonomaProvinciasSexo';
import ComunidadAutonomaProvinciasField from './ComunidadAutonomaProvinciasField';
import ComunidadAutonomaProvinciasCups from './ComunidadAutonomaProvinciasCups';

export interface IComunidadesAutonomasDetailState {
    comunidadesAutonomas: any[],
    selectedComunidadAutonoma: string,
    provincias: any[]
}

export default class ComunidadesAutonomasDetail extends React.Component<{}, IComunidadesAutonomasDetailState> {
    public constructor(props: {}) {
        super(props);

        this.state = {
            comunidadesAutonomas: [],
            selectedComunidadAutonoma: '',
            provincias: []
        }
    }

    componentDidMount(): void {
        this.Get();
    }

    public render(): React.ReactElement<{}> {
        return (
            <SecurityTrimmer entity={Entity.ComunidadesAutonomas} permission={PermissionLevel.Ver} noAccessMessage='No tiene permisos para ver este contenido.'>
                <Layout breadcrumb={
                    [
                        {
                            title: 'Inicio',
                            url: '/'
                        },
                        {
                            title: 'Comunidades autónomas',
                            url: ''
                        }
                    ]
                }>
                    <Box className='stepper'>
                        <Grid container>
                            <Grid item xs={1}>
                                <Typography>
                                    <HomeWorkOutlinedIcon className='mainIcon'/>
                                </Typography>
                            </Grid>
                            <Grid item xs={9}>
                                <Typography className='mainTitle'>
                                Comunidades autónomas
                                </Typography>
                            </Grid>
                            <SecurityTrimmer entity={Entity.ComunidadesAutonomas} permission={PermissionLevel.Administrar}>
                                <Grid item xs={2} className='entitySettings'>
                                    <EntityPermissions entity={Entity.IPS}/>
                                </Grid>
                            </SecurityTrimmer>
                        </Grid>
                    </Box>
                    <Box className='main transparent'>
                        <Grid container spacing={3}>
                            <Grid item xs={3}>
                                <Paper elevation={3} sx={{padding: '20px 5px'}} square>
                                    <Box display={'flex'} justifyContent={'space-between'} margin={'0px 10px'} marginBottom={'10px'} sx={{borderBottom: 'solid 1px #ccc'}}>
                                        <Typography variant="body2" component="div" sx={{cursor: 'pointer'}}>
                                            Comunidad
                                        </Typography>
                                        <Typography variant="body2" component="div">
                                            Nº Registros
                                        </Typography>
                                    </Box>
                                    {
                                        this.state.comunidadesAutonomas.map((comunidadAutonoma: any, index: number) => {
                                            return (
                                                <Box display={'flex'} justifyContent={'space-between'} marginBottom={'10px'} padding={'2px 10px'} key={index} sx={{backgroundColor: this.state.selectedComunidadAutonoma == comunidadAutonoma.comunidadAutonoma ? '#f4f4f4' : '#fff'}}>
                                                    <Typography variant="body2" component="div" sx={{cursor: 'pointer', position: 'relative', top: '5px'}} onClick={() => {
                                                        this.GetProvincias(comunidadAutonoma.comunidadAutonoma);
                                                    }}>
                                                        {
                                                            comunidadAutonoma.comunidadAutonoma
                                                        }
                                                    </Typography>
                                                    <Typography variant="body2" component="div">
                                                        <Chip label={comunidadAutonoma.total}/>
                                                    </Typography>
                                                </Box>
                                            )
                                        })
                                    }
                                </Paper>
                            </Grid>
                            <Grid item xs={9}>
                                <Grid container spacing={3}>
                                    {
                                        Common.IsNullOrEmpty(this.state.selectedComunidadAutonoma) && (
                                            <Grid item xs={12}>
                                                <Paper elevation={3} square sx={{padding: '20px'}}>
                                                    <Typography variant='h5'>
                                                        Seleccione una comunidad autónoma para ver el detalle
                                                    </Typography>
                                                </Paper>
                                            </Grid>
                                        )
                                    }
                                    {
                                        !Common.IsNullOrEmpty(this.state.selectedComunidadAutonoma) && (
                                            <React.Fragment>
                                                <Grid item xs={12}>
                                                    <Paper elevation={3} square sx={{padding: '20px'}}>
                                                        <Typography variant='h5'>
                                                            {
                                                                this.state.selectedComunidadAutonoma
                                                            }
                                                        </Typography>
                                                    </Paper>
                                                </Grid>
                                                {
                                                    this.state.provincias.length > 1 && (
                                                        <Grid item xs={12}>
                                                            <Paper elevation={3} square sx={{padding: '20px'}}>
                                                                <Typography variant='h6' style={{marginBottom: '20px'}}>
                                                                    Provincias
                                                                </Typography>
                                                                {
                                                                    this.state.provincias.map((provincia: any, index: number) => {
                                                                        return (
                                                                            <Button key={`prov-${index}`} variant='text' style={{margin: '5px', backgroundColor: '#fff', color: '#333'}} onClick={() => {
                                                                                window.location.href = `/summary/provincia?p=${provincia.provincia}&c=${this.state.selectedComunidadAutonoma}`;
                                                                            }}>
                                                                                {
                                                                                    provincia.provincia
                                                                                }
                                                                                <Chip label={provincia.total} style={{marginLeft: '5px'}}/>
                                                                            </Button>
                                                                        )
                                                                    })
                                                                }
                                                            </Paper>
                                                        </Grid>
                                                    )
                                                }
                                                <Grid item xs={3}>
                                                    <ComunidadAutonomaTotal comunidadAutonoma={this.state.selectedComunidadAutonoma} field='' title='Total' icon={<StorageIcon style={{fontSize: '32px', opacity: '.5'}}/>}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <ComunidadAutonomaTotal comunidadAutonoma={this.state.selectedComunidadAutonoma} sexField={true} field='h' title='Hombres' icon={<ManIcon style={{fontSize: '32px', opacity: '.5'}}/>} showChart={true} chartColor={Common.MAN_BORDER_COLOR}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <ComunidadAutonomaTotal comunidadAutonoma={this.state.selectedComunidadAutonoma} sexField={true} field='m' title='Mujeres' icon={<WomanIcon style={{fontSize: '32px', opacity: '.5'}}/>} showChart={true} chartColor={Common.WOMAN_BORDER_COLOR}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <ComunidadAutonomaTotal comunidadAutonoma={this.state.selectedComunidadAutonoma} field='FechaNacimiento' title='Fechas de nacimiento' icon={<CakeOutlinedIcon style={{fontSize: '32px', opacity: '.5'}}/>} showChart={true}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <ComunidadAutonomaTotal comunidadAutonoma={this.state.selectedComunidadAutonoma} field='Telefono' title='Telefonos' icon={<LocalPhoneOutlinedIcon style={{fontSize: '32px', opacity: '.5'}}/>} showChart={true}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <ComunidadAutonomaTotal comunidadAutonoma={this.state.selectedComunidadAutonoma} field='email' title='Emails' icon={<AlternateEmailOutlinedIcon style={{fontSize: '32px', opacity: '.5'}}/>} showChart={true}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <ComunidadAutonomaTotal comunidadAutonoma={this.state.selectedComunidadAutonoma} field='NombreVia' title='Nombres de vía' icon={<SignpostOutlinedIcon style={{fontSize: '32px', opacity: '.5'}}/>} showChart={true}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <ComunidadAutonomaTotal comunidadAutonoma={this.state.selectedComunidadAutonoma} field='tipoVia' title='Tipos de vía' icon={<TrafficOutlinedIcon style={{fontSize: '32px', opacity: '.5'}}/>} showChart={true}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <ComunidadAutonomaTotal comunidadAutonoma={this.state.selectedComunidadAutonoma} field='municipio' title='Municipios' icon={<HolidayVillageOutlinedIcon style={{fontSize: '32px', opacity: '.5'}}/>} showChart={true}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <ComunidadAutonomaTotal comunidadAutonoma={this.state.selectedComunidadAutonoma} field='provincia' title='Provincias' icon={<LocationCityOutlinedIcon style={{fontSize: '32px', opacity: '.5'}}/>} showChart={true}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <ComunidadAutonomaTotal comunidadAutonoma={this.state.selectedComunidadAutonoma} field='CupsLuz' title='CUPS Luz' icon={<LightOutlinedIcon style={{fontSize: '32px', opacity: '.5'}}/>} showChart={true}/>
                                                </Grid>
                                                <Grid item xs={3}>
                                                    <ComunidadAutonomaTotal comunidadAutonoma={this.state.selectedComunidadAutonoma} field='cupsLuz' title='CUPS Gas' icon={<LocalFireDepartmentOutlinedIcon style={{fontSize: '32px', opacity: '.5'}}/>} showChart={true}/>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <ComunidadAutonomaProvinciasSexo comunidadAutonoma={this.state.selectedComunidadAutonoma} />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <ComunidadAutonomaProvinciasField comunidadAutonoma={this.state.selectedComunidadAutonoma} field='telefono' label={'Teléfonos'} title='Teléfonos' color={Common.PALLETE[0]}/>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <ComunidadAutonomaProvinciasField comunidadAutonoma={this.state.selectedComunidadAutonoma} field='email' label={'Emails'} title='Emails' color={Common.PALLETE[1]}/>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <ComunidadAutonomaProvinciasCups comunidadAutonoma={this.state.selectedComunidadAutonoma} />
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <Typography variant='h5' component={'div'} style={{borderBottom: 'solid 1px #333'}}>
                                                        Dirección
                                                    </Typography>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <ComunidadAutonomaProvinciasField comunidadAutonoma={this.state.selectedComunidadAutonoma} field='TipoVia' label={'Tipos de vía'} title='Tipos de vía' color={Common.PALLETE[2]}/>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <ComunidadAutonomaProvinciasField comunidadAutonoma={this.state.selectedComunidadAutonoma} field='NombreVia' label={'Nombres de vía'} title='Nombres de vía' color={Common.PALLETE[3]}/>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <ComunidadAutonomaProvinciasField comunidadAutonoma={this.state.selectedComunidadAutonoma} field='NumeroVia' label={'Números de vía'} title='Números de vía' color={Common.PALLETE[3]}/>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <ComunidadAutonomaProvinciasField comunidadAutonoma={this.state.selectedComunidadAutonoma} field='RestoDireccion' label={'Resto direccion'} title='Resto direcciones' color={Common.PALLETE[3]}/>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <ComunidadAutonomaProvinciasField comunidadAutonoma={this.state.selectedComunidadAutonoma} field='cp' label={'Códigos postales'} title='Códigos postales' color={Common.PALLETE[3]}/>
                                                </Grid>
                                                <Grid item xs={12}>
                                                    <ComunidadAutonomaProvinciasField comunidadAutonoma={this.state.selectedComunidadAutonoma} field='municipio' label={'Municipios'} title='Municipios' color={Common.PALLETE[3]}/>
                                                </Grid>
                                            </React.Fragment>
                                        )
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                </Layout>
            </SecurityTrimmer>
        )
    }

    private Get() {
        let url = `${Common.END_POINT}/charts/comunidadesautonomas/total`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    comunidadesAutonomas: response
                }
            );
        })
    }

    private GetProvincias(comunidadAutonoma: string) {
        let url = `${Common.END_POINT}/charts/provincia/total/comunidadautonoma/${comunidadAutonoma}`;
        
        $.ajax((
            {
                url: url,
                type: "GET",
                headers: {
                    "Accept": "application/json",
                    "Content-Type": "application/json"
                },
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('Authorization', `Bearer ${Common.GetToken()}`);
                }
            }
        )).done((response: any[]) => {
            this.setState(
                {
                    provincias: response,
                    selectedComunidadAutonoma: comunidadAutonoma
                }
            );
        })
    }
}